import { useQuery } from '@tanstack/react-query'
import getMonitoringWorkflows from '../../services/ruutsApi/getMonitoringWorkflows'
import { queryKeys } from './queryKeys'

export const useMonitoringWorkflows = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: queryKeys.monitoringWorkflows(),
    queryFn: ({ signal }) => getMonitoringWorkflows({ signal }),
    enabled,
    // Reference data is immutable per deploy.
    staleTime: Infinity,
  })
